import { FormBuilder } from '../../modules/formBuilder'
import { KycInfo } from '../../modules/kycInfo'
import { LoadingScreen } from '../../modules/loadingScreen'
import Otp from '../../modules/otp'
import { ProductSelection } from '../../modules/productSelection'
import RedirectUrl from '../../modules/redirectComponent'
import Review from '../../modules/review'
import { StatusScreen } from '../../modules/statusScreen'
import { ApplicationMap } from '../applicationSatusMap'

export const hdfcCardStateMap = {
  HDFC_CC_START: {
    Component: LoadingScreen,
    props: {
      subTitle:
        'Please wait while we are checking your eligibility with HDFC Bank',
    },
  },
  HDFC_CC_PAN_DETAILS_FORM: {
    Component: FormBuilder,
    props: {
      disableConsents: true,
      consents: [
        `<p>
        I have read, understood, and agree to 
        <a href="https://www.hdfcbank.com/content/api/contentstream/723fb80a-2dde-42a3-9793-7ae1be57c87f/Common/pdf/Consent-Terms-and-General-TnC/Consent-Terms-and-General-TnC.pdf" style="text-decoration: underline; color: #596379;" target="_blank">
            Consent Terms and General Terms & Conditions
        </a>, 
        <a href="https://www.hdfcbank.com/content/bbp/repositories/723fb80a-2dde-42a3-9793-7ae1be57c87f/?path=/Personal/Pay/Cards/Credit%20Card/Credit%20Card%20Landing%20Page/Manage%20Your%20Credit%20Cards%20PDFs/MITC%201.64.pdf" style="text-decoration: underline; color: #596379;" target="_blank">
            Most Important Terms and Conditions
        </a>, 
        <a href="https://www.hdfcbank.com/content/bbp/repositories/723fb80a-2dde-42a3-9793-7ae1be57c87f/?path=/Personal/Pay/Cards/Credit%20Card/Credit%20Card%20Landing%20Page/card-member-agreement-29-10-2019.pdf" style="text-decoration: underline; color: #596379;" target="_blank">
            Card Member Agreement
        </a>, 
        <a href="https://www.hdfcbank.com/content/bbp/repositories/723fb80a-2dde-42a3-9793-7ae1be57c87f/?path=/Personal/Pay/Cards/Credit%20Card/Key%20Facts%20Statement/Content%20of%20Key%20fact%20statement%20002.pdf" style="text-decoration: underline; color: #596379;" target="_blank">
            Key Fact Statement
        </a>.
        I provide my express consent to HDFC Bank Limited ("Bank") and Vistas TechnoLabs Pvt. Ltd. for collecting, disclosing, sharing, displaying and transferring my personal, demographic information for my credit card application. 
        </p>`,
        '<div><p>By submitting, I confirm that I am an Indian above 18 years of age, residing in India and have read & agreed to HDFC Bank Privacy Policy and T&C. I agree to receive calls, SMS, WhatsApp messages from HDFC Bank for personalized offerings regarding new products.</div>',
      ],
    },
  },
  HDFC_CC_DEDUPE_INELIGIBLE_PROFILE: {
    Component: StatusScreen,
    props: {
      status: {
        title:
          'Sorry, Your chances of being eligible for \n HDFC Bank Credit Card are less',
        subTitle:
          'Your profile is not eligible as per criteria set by HDFC Bank. \n You can explore other options instead.',
        image: 'WARNING',
        applicationType: 'hdfc',
      },
      secondaryButton: {
        title: 'Explore Other Products',
        action: 'REDIRECT_NEXT_STATE',
        nextStateRedirect: 'HDFC_CC_RECOMMENDATION_FLOW',
      },
    },
  },
  HDFC_CC_DEDUPE_CHECK_PROGRESS: {
    Component: LoadingScreen,
    props: {
      title: 'Loading Application Form',
      subTitle: 'Please wait, we are currently loading your application form',
      timer: {
        enabled: true,
        onTimerEnd: ({ hash, navigation, state }) => {
          navigation?.replace?.('brandsCC', {
            hash,
            state,
          })
        },
        durationInSeconds: 60,
      },
      refresh: {
        shouldRefresh: true,
        refreshIntervalInSec: 5,
      },
      statusScreenProps: {
        status: {
          title: 'Oops! \n Something Went Wrong',
          subTitle:
            "We're currently unable to process this request due to a technical issue. Please try again.",
          image: 'SERVER_ERROR',
          applicationType: 'hdfc',
        },
        secondaryButton: {
          title: 'Reload Now',
          action: 'REDIRECT_NEXT_STATE',
          nextStateRedirect: 'HDFC_CC_DEDUPE_CHECK_PROGRESS',
          icon: 'PendingRounded',
        },
      },
    },
  },
  HDFC_CC_OTP_GENERATE: {
    Component: Otp,
    props: {
      maskNumber: true,
      hideTnC: true,
      hideOTPMessage: true,
    },
  },
  HDFC_CC_OTP_EXCEED_LIMIT_ERROR: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Oh No!\nYou have exceeded the maximum \nno. of OTP attempts',
        image: 'ERROR_RETRY',
        applicationType: 'hdfc',
      },
      showTimeLeft: true,
    },
  },
  HDFC_CC_OTP_SUBMISSION_PROGRESS: {
    Component: LoadingScreen,
    props: {
      title: 'Loading Application Form',
      subTitle: 'Please wait, we are currently loading your application form',
      timer: {
        enabled: true,
        onTimerEnd: ({ hash, navigation, state }) => {
          navigation?.replace?.('brandsCC', {
            hash,
            state,
          })
        },
        durationInSeconds: 60,
      },
      refresh: {
        shouldRefresh: true,
        refreshIntervalInSec: 5,
      },
      statusScreenProps: {
        status: {
          title: 'Oops! \n Something Went Wrong',
          subTitle:
            "We're currently unable to process this request due to a technical issue. Please try again.",
          image: 'SERVER_ERROR',
          applicationType: 'hdfc',
        },
        secondaryButton: {
          title: 'Reload Now',
          action: 'REDIRECT_NEXT_STATE',
          nextStateRedirect: 'HDFC_CC_OTP_SUBMISSION_PROGRESS',
          icon: 'PendingRounded',
        },
      },
    },
  },
  HDFC_CC_PERSONAL_DETAILS_FORM: {
    Component: FormBuilder,
  },
  HDFC_CC_ADDRESS_DETAILS_FORM: {
    Component: FormBuilder,
  },
  HDFC_CC_EMPLOYMENT_DETAILS_FORM: {
    Component: FormBuilder,
  },
  HDFC_CC_CUSTOMER_DETAILS_REVIEW_FORM: {
    Component: Review,
  },
  HDFC_CC_CUSTOMER_DETAILS_SUBMISSION_PROGRESS: {
    Component: LoadingScreen,
    props: {
      title: 'Please Wait! \n Checking Your Eligibility',
      subTitle:
        'Please wait while we are checking your \n eligibility with HDFC Bank',
      timer: {
        enabled: true,
        onTimerEnd: ({ hash, navigation, state }) => {
          navigation?.replace?.('brandsCC', {
            hash,
            state,
          })
        },
        durationInSeconds: 75,
      },
      refresh: {
        shouldRefresh: true,
        refreshIntervalInSec: 5,
      },
      statusScreenProps: {
        status: {
          title: 'Oops! \n Something Went Wrong',
          subTitle:
            "We're currently unable to process this request due to a technical issue. Please try again.",
          image: 'SERVER_ERROR',
          applicationType: 'hdfc',
        },
        secondaryButton: {
          title: 'Reload Now',
          action: 'REDIRECT_NEXT_STATE',
          nextStateRedirect: 'HDFC_CC_CUSTOMER_DETAILS_SUBMISSION_PROGRESS',
          icon: 'PendingRounded',
        },
      },
    },
  },
  HDFC_CC_IPA_REJECTED: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Oh No! \n Application Rejected',
        subTitle:
          'We are unable to process your Credit Card application as per our Partner Bank’s eligibility criteria',
        image: 'DOCUMENT_CROSS',
        applicationType: 'hdfc',
      },
    },
  },
  HDFC_CC_IPA_PERFIOUS_START: {
    Component: FormBuilder,
  },
  HDFC_CC_IPA_PERFIOUS_AA: {
    Component: FormBuilder,
  },
  HDFC_CC_IPA_RECHECK_PROGRESS: {
    Component: LoadingScreen,
    props: {
      title: 'Please Wait! \n Checking Your Eligibility',
      subTitle:
        'Please wait while we are checking your \n eligibility with HDFC Bank',
      timer: {
        enabled: true,
        onTimerEnd: ({ hash, navigation, state }) => {
          navigation?.replace?.('brandsCC', {
            hash,
            state,
          })
        },
        durationInSeconds: 60,
      },
      refresh: {
        shouldRefresh: true,
        refreshIntervalInSec: 5,
      },
      statusScreenProps: {
        status: {
          title: 'Oops! \n Something Went Wrong',
          subTitle:
            "We're currently unable to process this request due to a technical issue. Please try again.",
          image: 'SERVER_ERROR',
          applicationType: 'hdfc',
        },
        secondaryButton: {
          title: 'Reload Now',
          action: 'REDIRECT_NEXT_STATE',
          nextStateRedirect: 'HDFC_CC_IPA_RECHECK_PROGRESS',
          icon: 'PendingRounded',
        },
      },
    },
  },
  HDFC_CC_PRODUCT_SELECTION: {
    Component: ProductSelection,
    props: {
      backgroundGradientColors: ['#8D8D8D', '#000000'],
      consents: [
        `<p style='margin-left:0'>I confirm that I have read, understood and agree to card price and features</p>`,
      ],
    },
  },
  HDFC_CC_OTHER_DETAILS_FORM: {
    Component: FormBuilder,
  },
  HDFC_CC_ETB_IDCOMM_FLOW: {
    Component: FormBuilder,
  },
  HDFC_CC_ETB_NTB_IN_PERSON_KYC_FLOW: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Thank You!',
        subTitle:
          'Your application has been submitted successfully. An HDFC team member will contact you soon for KYC verification. If you have any questions, feel free to reach out to your financial advisor.',
        image: 'DOCUMENT_PERSON',
        applicationType: 'hdfc',
      },
    },
  },
  HDFC_CC_ETB_EKYC_IDCOMM_FLOW: {
    Component: FormBuilder,
  },
  HDFC_CC_ETB_EKYC_IDCOMM_PROGRESS: {
    Component: LoadingScreen,
    props: {
      title:
        'Please Wait! \n Redirecting You to Net-Banking/Debit Card Verification',
      subTitle:
        'We are redirecting you to HDFC Net-banking/Debit Card based KYC verification',
      timer: {
        enabled: true,
        onTimerEnd: ({ hash, navigation, state }) => {
          navigation?.replace?.('brandsCC', {
            hash,
            state,
          })
        },
        durationInSeconds: 60,
      },
      refresh: {
        shouldRefresh: true,
        refreshIntervalInSec: 5,
      },
      statusScreenProps: {
        status: {
          title: 'Oops! \n Something Went Wrong',
          subTitle:
            "We're currently unable to process this request due to a technical issue. Please try again.",
          image: 'SERVER_ERROR',
          applicationType: 'hdfc',
        },
        secondaryButton: {
          title: 'Reload Now',
          action: 'REDIRECT_NEXT_STATE',
          nextStateRedirect: 'HDFC_CC_ETB_EKYC_IDCOMM_PROGRESS',
          icon: 'PendingRounded',
        },
      },
    },
  },
  HDFC_CC_ETB_EKYC_VKYC_IDCOM_PROGRESS: {
    Component: LoadingScreen,
    props: {
      title:
        'Please Wait! \n Redirecting You to Net-Banking/Debit Card Verification',
      subTitle:
        'We are redirecting you to HDFC Net-banking/Debit Card based KYC verification',
      timer: {
        enabled: true,
        onTimerEnd: ({ hash, navigation, state }) => {
          navigation?.replace?.('brandsCC', {
            hash,
            state,
          })
        },
        durationInSeconds: 60,
      },
      refresh: {
        shouldRefresh: true,
        refreshIntervalInSec: 5,
      },
      statusScreenProps: {
        status: {
          title: 'Oops! \n Something Went Wrong',
          subTitle:
            "We're currently unable to process this request due to a technical issue. Please try again.",
          image: 'SERVER_ERROR',
          applicationType: 'hdfc',
        },
        secondaryButton: {
          title: 'Reload Now',
          action: 'REDIRECT_NEXT_STATE',
          nextStateRedirect: 'HDFC_CC_ETB_EKYC_VKYC_IDCOM_PROGRESS',
          icon: 'PendingRounded',
        },
      },
    },
  },
  HDFC_CC_NTB_VKYC_FLOW_FORM: {
    Component: KycInfo,
    props: {
      type: 'video_kyc',
      buttons: [
        {
          icon: 'AssignedFilled',
          title: 'Continue with Video KYC',
          action: 'STATE_MACHINE_POST',
          eventValue: 'VIDEO_KYC',
        },
      ],
    },
  },
  HDFC_CC_APPLICATION_UNDER_REVIEW: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Thank You!\nYour Application Has Been Submitted',
        subTitle:
          'Your application is under review with the Bank Credit Cards team. You will be notified once it is reviewed. For any assistance, feel free to contact your financial advisor.',
        image: 'DOCUMENT_SEARCH',
        status: ApplicationMap['under_review'],
        applicationType: 'hdfc',
      },
    },
  },
  HDFC_CC_APPLICATION_CORRECTION_REQUIRED: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Uh-Oh! \n More Information Required',
        subTitle:
          'HDFC needs more information to process your application. An HDFC Bank executive will reach out to you shortly. For any assistance, feel free to contact your financial advisor.',
        image: 'DOCUMENT_WARN',
        status: ApplicationMap['correction_required'],
        applicationType: 'hdfc',
      },
    },
  },
  HDFC_CC_APPLICATION_REJECTED: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Oh No! \n Application Rejected',
        subTitle:
          'We are unable to process your Credit Card application as per our Partner Bank’s eligibility criteria',
        image: 'DOCUMENT_CROSS',
        status: ApplicationMap['application_rejected'],
        applicationType: 'hdfc',
      },
    },
  },
  HDFC_CC_APPLICATION_APPROVED: {
    // TODO
    Component: StatusScreen,
    props: {
      status: {
        title: 'Congratulation!',
        subTitle:
          'HDFC Bank will share tracking details on your phone. Please keep checking your SMS for the status of card delivery.',
        getImageByUrl: true,
        applicationType: 'hdfc',
        confetti: true,
        gradientConfig: {
          backgroundGradient: {
            colors: ['#15468B', '#000000', '#050E1A', '#296ECF'],
            locations: [-0.0465, 0.2782, 0.8232, 1.0668],
            start: { x: 0.75, y: 0 },
            end: { x: 0.25, y: 1 },
          },
          detailsHeaderGradientConfig: {
            colors: ['#000000', '#296ECF'],
            locations: [-0.0015, 0.9985],
            start: { x: 1, y: 0 },
            end: { x: 0, y: 0 },
          },
          detailsBodyConfig: {
            bgColor: '#061528',
          },
        },

        textColor: 'text-white',
        status: ApplicationMap['dispatched'],
        subHeading: 'Your card has been approved.',
      },
    },
  },
  HDFC_CC_SOMETHING_WENT_WRONG: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Oops! \n Something Went Wrong',
        subTitle:
          "We're currently unable to process this request due to a technical issue. Please try again.",
        image: 'SERVER_ERROR',
        applicationType: 'hdfc',
      },
      secondaryButton: {
        title: 'Retry',
        action: 'REDIRECT_NEXT_STATE',
        icon: 'PendingRounded',
        nextStateRedirect: 'HDFC_CC_SOMETHING_WENT_WRONG',
      },
    },
  },
  HDFC_CC_NTB_EKYC_FLOW_FORM: {
    Component: FormBuilder,
    props: {
      shareEvent: true,
      showArnNumber: true,
      buttonProps: {
        title: 'Continue with KYC',
        icon: 'USER_VERIFIED',
      },
    },
  },
  HDFC_CC_NTB_DIGITAL_KYC: {
    Component: RedirectUrl,
  },
  HDFC_CC_ETB_EKYC_DIGITAL_KYC: {
    Component: RedirectUrl,
  },
  HDFC_CC_IPA_PERFIOS_START_FORM: {
    Component: FormBuilder,
  },
  HDFC_CC_AA_PROGRESS: {
    Component: LoadingScreen,
    props: {
      title: 'Please Wait! \n Checking Your Eligibility',
      subTitle:
        'Please wait while we are checking your \n eligibility with HDFC Bank',
      timer: {
        enabled: true,
        onTimerEnd: ({ hash, navigation, state }) => {
          navigation?.replace?.('brandsCC', {
            hash,
            state,
          })
        },
        durationInSeconds: 330,
      },
      refresh: {
        shouldRefresh: true,
        refreshIntervalInSec: 20,
      },
      statusScreenProps: {
        status: {
          title: 'Oops! \n Something Went Wrong',
          subTitle:
            "We're currently unable to process this request due to a technical issue. Please try again.",
          image: 'SERVER_ERROR',
          applicationType: 'hdfc',
        },
        secondaryButton: {
          title: 'Reload Now',
          action: 'REDIRECT_NEXT_STATE',
          nextStateRedirect: 'HDFC_CC_AA_PROGRESS',
          icon: 'PendingRounded',
        },
      },
    },
  },
  HDFC_CC_IPA_PERFIOS_AA_FORM: {
    Component: FormBuilder,
  },
  HDFC_CC_NTB_EKYC_DIGITAL_KYC_PROGRESS: {
    Component: LoadingScreen,
    props: {
      title: 'Loading Application Form',
      subTitle: 'Please wait, we are currently loading your application form',
      refresh: {
        shouldRefresh: true,
        refreshIntervalInSec: 5,
      },
      statusScreenProps: {
        status: {
          title: 'Oops! \n Something Went Wrong',
          subTitle:
            "We're currently unable to process this request due to a technical issue. Please try again.",
          image: 'SERVER_ERROR',
          applicationType: 'hdfc',
        },
        secondaryButton: {
          title: 'Reload Now',
          action: 'REDIRECT_NEXT_STATE',
          nextStateRedirect: 'HDFC_CC_NTB_EKYC_DIGITAL_KYC_PROGRESS',
          icon: 'PendingRounded',
        },
      },
    },
  },
  HDFC_CC_IPA_PERFIOS_LOGIN: {
    Component: StatusScreen,
    props: {
      status: {
        title:
          'Sorry, Your chances of being eligible for \n HDFC Bank Credit Card are less',
        subTitle:
          'Your profile is not eligible as per criteria set by HDFC Bank. \n You can explore other options instead.',
        image: 'WARNING',
        applicationType: 'hdfc',
      },
      timer: {
        enabled: true,
        onTimerEnd: ({ hash, navigation, state }) => {
          navigation?.replace?.('brandsCC', {
            hash,
            state,
          })
        },
        // durationInSeconds: 60,
      },
      secondaryButton: {
        title: 'Explore Other Products',
        action: 'REDIRECT_NEXT_STATE',
        nextStateRedirect: 'STATE_MACHINE_POST',
      },
    },
  },
  HDFC_CC_ETB_IDCOM_FLOW_FORM: {
    Component: FormBuilder,
    props: {
      buttonProps: {
        title: 'Continue with Verification',
        icon: 'USER_VERIFIED',
      },
      showArnNumber: true,
    },
  },
  HDFC_CC_ETB_IDCOM_LOGIN_PROGRESS: {
    Component: LoadingScreen,
    props: {
      title: 'Loading Application Form',
      subTitle: 'Please wait, we are currently loading your application form',
      timer: {
        enabled: true,
        onTimerEnd: ({ hash, navigation, state }) => {
          navigation?.replace?.('brandsCC', {
            hash,
            state,
          })
        },
        durationInSeconds: 60,
      },
      refresh: {
        shouldRefresh: true,
        refreshIntervalInSec: 5,
      },
      statusScreenProps: {
        status: {
          title: 'Oops! \n Something Went Wrong',
          subTitle:
            "We're currently unable to process this request due to a technical issue. Please try again.",
          image: 'SERVER_ERROR',
          applicationType: 'hdfc',
        },
        secondaryButton: {
          title: 'Reload Now',
          action: 'REDIRECT_NEXT_STATE',
          nextStateRedirect: 'HDFC_CC_ETB_IDCOM_LOGIN_PROGRESS',
          icon: 'PendingRounded',
        },
      },
    },
  },
  HDFC_CC_ETB_EKYC_FLOW_FORM: {
    Component: FormBuilder,
    props: {
      shareEvent: true,
      showArnNumber: true,
      buttonProps: {
        title: 'Continue with KYC',
        icon: 'USER_VERIFIED',
      },
    },
  },
  HDFC_CC_ETB_EKYC_VKYC_IDCOM_FLOW_FORM: {
    Component: KycInfo,
    props: {
      type: 'video_kyc',

      buttons: [
        {
          icon: 'AssignedFilled',
          title: 'Continue with Video KYC',
          action: 'STATE_MACHINE_POST',
          eventValue: 'VIDEO_KYC',
        },
      ],
    },
  },
  HDFC_CC_ETB_NTB_BIOMETRIC_KYC: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Next Step \n In-person Biometric KYC!',
        subTitle:
          'Bank authorised representative will visit you for Aadhaar KYC using Biometric device. For any assistance, feel free to contact your financial advisor.',
        image: 'INPERSON_KYC',
        applicationType: 'hdfc',
        status: ApplicationMap['under_review'],
      },
    },
  },
  HDFC_CC_IPA_RESPONSE_PROGRESS: {
    Component: LoadingScreen,
    props: {
      title: 'Please Wait! \n Checking Your Eligibility',
      subTitle:
        'Please wait while we are checking your \n eligibility with HDFC Bank',
      timer: {
        enabled: true,
        onTimerEnd: ({ hash, navigation, state }) => {
          navigation?.replace?.('brandsCC', {
            hash,
            state,
          })
        },
        durationInSeconds: 60,
      },
      refresh: {
        shouldRefresh: true,
        refreshIntervalInSec: 5,
      },
      statusScreenProps: {
        status: {
          title: 'Oops! \n Something Went Wrong',
          subTitle:
            "We're currently unable to process this request due to a technical issue. Please try again.",
          image: 'SERVER_ERROR',
          applicationType: 'hdfc',
        },
        secondaryButton: {
          title: 'Reload Now',
          action: 'REDIRECT_NEXT_STATE',
          nextStateRedirect: 'HDFC_CC_IPA_RESPONSE_PROGRESS',
          icon: 'PendingRounded',
        },
      },
    },
  },
  HDFC_CC_ETB_BIOKYC_IDCOM_LOGIN_PROGRESS: {
    Component: LoadingScreen,
    props: {
      title: 'Loading Application Form',
      subTitle: 'Please wait, we are currently loading your application form',
      timer: {
        enabled: true,
        onTimerEnd: ({ hash, navigation, state }) => {
          navigation?.replace?.('brandsCC', {
            hash,
            state,
          })
        },
        durationInSeconds: 60,
      },
      refresh: {
        shouldRefresh: true,
        refreshIntervalInSec: 5,
      },
      statusScreenProps: {
        status: {
          title: 'Oops! \n Something Went Wrong',
          subTitle:
            "We're currently unable to process this request due to a technical issue. Please try again.",
          image: 'SERVER_ERROR',
          applicationType: 'hdfc',
        },
        secondaryButton: {
          title: 'Reload Now',
          action: 'REDIRECT_NEXT_STATE',
          nextStateRedirect: 'HDFC_CC_ETB_BIOKYC_IDCOM_LOGIN_PROGRESS',
          icon: 'PendingRounded',
        },
      },
    },
  },
  HDFC_CC_ETB_EKYC_IDCOM_LOGIN_PROGRESS: {
    Component: LoadingScreen,
    props: {
      title: 'Loading Application Form',
      subTitle: 'Please wait, we are currently loading your application form',
      timer: {
        enabled: true,
        onTimerEnd: ({ hash, navigation, state }) => {
          navigation?.replace?.('brandsCC', {
            hash,
            state,
          })
        },
        durationInSeconds: 60,
      },
      refresh: {
        shouldRefresh: true,
        refreshIntervalInSec: 5,
      },
      statusScreenProps: {
        status: {
          title: 'Oops! \n Something Went Wrong',
          subTitle:
            "We're currently unable to process this request due to a technical issue. Please try again.",
          image: 'SERVER_ERROR',
          applicationType: 'hdfc',
        },
        secondaryButton: {
          title: 'Reload Now',
          action: 'REDIRECT_NEXT_STATE',
          nextStateRedirect: 'HDFC_CC_ETB_EKYC_IDCOM_LOGIN_PROGRESS',
          icon: 'PendingRounded',
        },
      },
    },
  },
  HDFC_CC_ETB_EKYC_CURRENT_ADDRESS_CONFIRMATION_FORM: {
    Component: FormBuilder,
  },
  HDFC_CC_NTB_CURRENT_ADDRESS_CONFIRMATION_FORM: {
    Component: FormBuilder,
  },
  HDFC_CC_ETB_EKYC_CURRENT_ADDRESS_CONFIRMATION_PROGRESS: {
    Component: LoadingScreen,
    props: {
      title: 'Loading Application Form',
      subTitle: 'Please wait, we are currently loading your application form',
      refresh: {
        shouldRefresh: true,
        refreshIntervalInSec: 5,
      },
      statusScreenProps: {
        status: {
          title: 'Oops! \n Something Went Wrong',
          subTitle:
            "We're currently unable to process this request due to a technical issue. Please try again.",
          image: 'SERVER_ERROR',
          applicationType: 'hdfc',
        },
        secondaryButton: {
          title: 'Reload Now',
          action: 'REDIRECT_NEXT_STATE',
          nextStateRedirect:
            'HDFC_CC_ETB_EKYC_CURRENT_ADDRESS_CONFIRMATION_PROGRESS',
          icon: 'PendingRounded',
        },
      },
    },
  },
  HDFC_CC_NTB_VKYC_VIDEO_KYC_STATIC_SCREEN: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Application Under Process',
        subTitle:
          'Thank you for completing your VKYC process. We kindly request you to wait while we retrieve your VKYC status from the Hdfc bank.',
        image: 'DOCUMENT_SEARCH',
        applicationType: 'hdfc',
      },
    },
  },
  HDFC_CC_ETB_EKYC_BIOKYC_PROGRESS: {
    Component: LoadingScreen,
    props: {
      title: 'Loading Application Form',
      subTitle: 'Please wait, we are currently loading your application form',
      refresh: {
        shouldRefresh: true,
        refreshIntervalInSec: 5,
      },
      statusScreenProps: {
        status: {
          title: 'Oops! \n Something Went Wrong',
          subTitle:
            "We're currently unable to process this request due to a technical issue. Please try again.",
          image: 'SERVER_ERROR',
          applicationType: 'hdfc',
        },
        secondaryButton: {
          title: 'Reload Now',
          action: 'REDIRECT_NEXT_STATE',
          nextStateRedirect: 'HDFC_CC_ETB_EKYC_BIOKYC_PROGRESS',
          icon: 'PendingRounded',
        },
      },
    },
  },
  HDFC_CC_NTB_VKYC_REJECTED: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Oh No! \n Application Rejected',
        subTitle:
          'We regret to inform you that your application has been rejected as the Video KYC process could not be successfully completed.',
        image: 'DOCUMENT_CROSS',
        applicationType: 'hdfc',
      },
    },
  },
}
